import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { Duration } from 'date-fns'
import { noop, Observable, switchMap } from 'rxjs'
import { shareReplay, take, tap } from 'rxjs/operators'
import { appConfig } from '../../../../brands/_current/config/app-config'
import { LoginService } from '../../../login/shared/login.service'
import { PendingData } from '../../../pending-operation/shared/pending-data.model'
import { temporaryBlockedRetryUrl } from '../../../pending-operation/shared/pending-operation-params'
import { PendingOperationService } from '../../../pending-operation/shared/pending-operation.service'
import { getCountdownDuration } from '../../../shared/countdown-duration'
import { getTemporaryBlockExpiration } from '../../store/selectors'

@Component({
  selector: 'app-temporary-blocked-account-page',
  templateUrl: './temporary-blocked-account-page.component.html',
  styleUrls: ['./temporary-blocked-account-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemporaryBlockedAccountPageComponent implements OnInit {
  helplineNumber: string
  temporaryBlockCountdown$: Observable<Duration | null>
  retryUrl: string[] | null
  pendingData: PendingData | null = null
  newCodeLabel: string = $localize`Riprova tra`
  messageLabel: string

  constructor(
    private readonly router: Router,
    private readonly store: Store,
    private readonly route: ActivatedRoute,
    private readonly pendingOperationService: PendingOperationService,
    private readonly loginService: LoginService,
  ) {}

  ngOnInit(): void {
    this.helplineNumber = appConfig.core.helplineNumber
    this.temporaryBlockCountdown$ = this.store.select(getTemporaryBlockExpiration).pipe(
      switchMap((date) => getCountdownDuration(date)),
      tap((countdown) => {
        if (countdown) {
          this.messageLabel = `${this.newCodeLabel} ${this.pendingOperationService.formatDurationToString(countdown)}`
        }
      }),
      shareReplay(1),
    )

    this.route.data
      .pipe(
        take(1),
        tap((data) => {
          this.retryUrl = data[temporaryBlockedRetryUrl]
          this.pendingData = data.pendingData
        }),
      )
      .subscribe()
  }

  onSendButtonClick() {
    if (this.retryUrl) {
      this.router
        .navigate(this.retryUrl, {
          queryParamsHandling: 'merge',
          state: {
            ...this.pendingData,
          },
        })
        .then(noop)
    } else {
      this.loginService.backToLogin().subscribe()
    }
  }
}
